export const PHONE_DISPLAY = "0537706725";
export const PHONE_TEL = "tel:0537706725";
export const WHATSAPP_URL =
    "https://wa.me/966537706725?text=%D9%85%D8%B1%D8%AD%D8%A8%D8%A7%D9%8B%D8%8C%20%D8%A3%D8%AD%D8%AA%D8%A7%D8%AC%20%D8%AE%D8%AF%D9%85%D8%A9%20%D8%B7%D8%A7%D8%B1%D8%A6%D8%A9%20%D9%84%D9%84%D9%85%D9%81%D8%A7%D8%AA%D9%8A%D8%AD%20%D9%88%D8%A7%D9%84%D8%A3%D9%82%D9%81%D8%A7%D9%84";

export const GALLERY_ITEMS = [
    {
        url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_simple-landing-63/artifacts/24a257f9285946a2_Car%20Keys%20Made%20Services.jpg",
        title: "مفاتيح ذكية وريموتات لكل الموديلات",
        category: "مفاتيح ذكية",
    },
    {
        url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_simple-landing-63/artifacts/606b3ca1f3f7c3ed_Get%20a%20spare%20key%20with%20ease_.jpg",
        title: "نصنع مفتاحاً جديداً حتى لو ضاع آخر مفتاح",
        category: "برمجة ونسخ",
    },
    {
        url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_simple-landing-63/artifacts/cc94d15a382b7e69_We%20rekey%20and%20make%20copies%20of%20keys%20for%20cars%E2%80%A6.jpg",
        title: "برمجة الريموت والمفاتيح الاحتياطية",
        category: "ريموتات",
    },
    {
        url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_simple-landing-63/artifacts/589a198e812f0e13_%D9%85%D9%88%D9%82%D8%B9%20%D9%86%D8%A7%D8%B0%D8%B1%20%D9%8A%D9%82%D8%AF%D9%85%20%D9%83%D9%8A%D9%81%D9%8A%D8%A9%20%D8%A8%D8%B1%D9%85%D8%AC%D8%A9%20%D9%85%D9%81%D8%A7%D8%AA%D9%8A%D8%AD%20%D8%A7%D9%84%D8%B3%D9%8A%D8%A7%D8%B1%D8%A7%D8%AA%20%D9%88%20%D8%A7%D9%84%D8%B4%D8%A7%D8%AD%D9%86%D8%A7%D8%AA.jpg",
        title: "مفاتيح لجميع الماركات — تويوتا، نيسان، هوندا وأكثر",
        category: "مفاتيح سيارات",
    },
    {
        url: "https://images.unsplash.com/photo-1749477417968-2bc986bc6a42?crop=entropy&cs=srgb&fm=jpg&q=85",
        title: "قص وتشكيل المفاتيح بدقة عالية",
        category: "قص مفاتيح",
    },
];
